import Client from "./Clients/AxiosClient";
const resource = "/api/v1/user/bundles";

export default {
  get(page, perPage, search) {
    return Client.get(`${resource}`, {
      params: {
        page,
        per_page: perPage,
        search,
        sort_field: "created_at",
        sort_direction: "asc",
      },
    });
  },
  getDetail(id) {
    return Client.get(`${resource}/${id}`);
  },
  getProductOfBundle(id, params) {
    return Client.get(`${resource}/${id}/products`, {
      params: {
        page_size: 999,
        ...params,
      }
    });
  },
};
